package com.iregained.site.pages

import androidx.compose.runtime.Composable
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.sections.corporate.data.mergedPrivacyAndCookiePolicyPayloads
import com.iregained.site.components.sections.corporate.sections.defaultCookieMatrixData
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page

@Page("/privacy-policy")
@Composable
fun PrivacyPolicyPage() {
    // Map initial state list to configured corporate payloads directly
    val pageSections: List<CmsSection> = buildList {
        mergedPrivacyAndCookiePolicyPayloads.forEach { policyData ->
            // Add the standard corporate policy section
            add(CmsSection.CorporatePolicySection(policyData))

            // Immediately following the cookie intro section, inject the matrix table
            if (policyData.sectionId == "cookie-intro") {
                add(CmsSection.CookieMatrixSection(defaultCookieMatrixData))
            }
        }
    }

    PageLayout {
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}